"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createParticle = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

// TEMP FILE TO PLAY AROUND WITH THE ANIMATION EFFECTS
var SIZE = 34;
var DELAY = 200;
var DURATION = 400;
var ROTATION = 520;
var DISTANCE_X = 70;
var DISTANCE_Y = -90;
var removeParticle = function removeParticle(event) {
  event.target.effect.target.remove();
};
var createParticle = exports.createParticle = function createParticle(icon, x, y) {
  var particle = document.createElement("particle");
  particle.innerHTML = icon;
  particle.style.fontSize = "".concat(Math.random() * SIZE, "px");
  var destinationX = (Math.random() - 0.5) * DISTANCE_X;
  var destinationY = (Math.random() + 0.5) * DISTANCE_Y;
  var rotate = Math.random() * ROTATION;
  document.body.appendChild(particle);
  var animation = particle.animate([{
    transform: "translate(-50%, -50%) translate(".concat(x, "px, ").concat(y, "px) rotate(0deg)"),
    opacity: 1
  }, {
    transform: "translate(-50%, -50%) translate(".concat(x + destinationX, "px, ").concat(y + destinationY, "px) rotate(").concat(rotate, "deg)"),
    opacity: 0
  }], {
    easing: "cubic-bezier(0, .9, .57, 1)",
    duration: Math.random() * 1000 + DURATION,
    delay: Math.random() * DELAY
  });
  animation.onfinish = removeParticle;
};